module.exports = __webpack_public_path__ + "media/images/icons/filled/star-731c34ac8d2f1eafc87e5b0b3aaa3eba.svg";